import React from "react";
import { breakpoints, useMediaQuery } from "@tvg/design-system";
import { isXSell } from "@tvg/sh-utils/mobileUtils";
import SeoContent, { SeoProps } from "../PromoSeoContent";
import HandicappingSection from "../HandicappingSection";
import { RowContainer } from "./styled-components";

interface Props {
  seoContent: SeoProps["content"];
}

const HandicappingAndSeoRow = ({ seoContent }: Props) => {
  const isMobile = useMediaQuery(breakpoints.tablet.max.sm);

  return (
    <RowContainer isMobile={isMobile}>
      {isMobile ? (
        <>
          {!isXSell() && <HandicappingSection isFromHomePage />}
          <SeoContent content={seoContent} />
        </>
      ) : (
        <>
          <SeoContent content={seoContent} />
          <HandicappingSection isFromHomePage />
        </>
      )}
    </RowContainer>
  );
};

export default HandicappingAndSeoRow;
